export default __webpack_public_path__ + "static/media/team1.a1135fcb.JPG";